// extracted by mini-css-extract-plugin
export default {"tab":"style_tab__Q8Pf1"};